import { AlertTriangle, Check, Info, X, XCircle } from 'lucide-react';
import { ToastMessage } from '../types';

interface ToastsProps {
  toasts: ToastMessage[];
  removeToast: (id: string) => void;
}

export default function Toasts({ toasts, removeToast }: ToastsProps) {
  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-20 right-4 md:bottom-14 md:right-6 left-4 md:left-auto z-9999 flex flex-col gap-2 pointer-events-none max-w-sm w-[calc(100%-2rem)] md:w-80">
      {toasts.map((toast) => {
        let borderClass = 'border-l-4 border-[#aace16]';
        let Icon = Info;
        let iconColor = 'text-[#aace16]';

        if (toast.type === 'success') {
          borderClass = 'border-l-4 border-[#aace16]';
          Icon = Check;
          iconColor = 'text-[#aace16]';
        } else if (toast.type === 'warning') {
          borderClass = 'border-l-4 border-[#f5a623]';
          Icon = AlertTriangle;
          iconColor = 'text-amber-400';
        } else if (toast.type === 'error') {
          borderClass = 'border-l-4 border-[#ff4f6a]';
          Icon = XCircle;
          iconColor = 'text-rose-400';
        }

        return (
          <div
            key={toast.id}
            className={`pointer-events-auto bg-[var(--bg-2)] border border-[var(--border)] shadow-xl rounded-lg overflow-hidden flex items-start gap-3 p-3 text-sm text-[var(--text-1)] transition-all duration-300 translate-x-0 ${borderClass}`}
          >
            <div className={`mt-0.5 flex-shrink-0 ${iconColor}`}>
              <Icon className="w-4.5 h-4.5" />
            </div>
            <div className="flex-1 font-medium">{toast.text}</div>
            <button
              onClick={() => removeToast(toast.id)}
              className="text-[var(--text-3)] hover:text-[var(--text-2)] transition-colors p-0.5"
              aria-label="Close notification"
            >
              <X className="w-3.5 h-3.5" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
